import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService, ModalService, RestServices, SharedServices } from '@app/services'
import { FormBuilder } from '@angular/forms'
import { imageUrl } from '@helpers/common'

@Component({
    selector: 'app-modal-broadcast-mail-failed',
    templateUrl: './modal-broadcast-mail-failed.component.html',
    styleUrls: [
        './modal-broadcast-mail-failed.css',
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../../stagingcss/image-viewer.component.css',
    ],
})

export class ModalBroadcastMailFailedComponent implements OnInit {

    hiddenModalBroadcastMailFailedHistory = 'hidden'
    hiddenModalBroadcastMailPreviewHistory = 'hidden'
    en: {}
    getBroadcastMailId: any
    imageUrl = imageUrl
    pauseVideo = true
    hostKeyboard: String = 'ModalBroadcastMailFailedComponent-hostKeyboard'

    constructor(private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private _sharedService: SharedServices, private modalService: ModalService) {
        this.modalService.changeEmitted$.subscribe(success => {
            if (success) {
                if (success.modal === 'BroadcastMailFailure') {
                    this.hiddenModalBroadcastMailFailedHistory = 'active'
                } else if (success.modal === 'BroadcastMailPreview') {
                    this.hiddenModalBroadcastMailPreviewHistory = 'active'
                }
                this.getBroadcastMailId = success
            }
        })
    }

    // hiden modal
    hiddenModalBroadcastMailFailed() {
        this.hiddenModalBroadcastMailFailedHistory = 'hidden'
    }

    hiddenModalBroadcastMailPreview() {
        this.hiddenModalBroadcastMailPreviewHistory = 'hidden'
    }

    renderBouncedList(list) {
        return list.join('\n')
    }

    ngOnInit() {
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent, ModalBroadcastMailFailedComponent: String = 'ModalBroadcastMailFailedComponent-hostKeyboard') {
        if (ModalBroadcastMailFailedComponent === this.hostKeyboard) {
            const keyPressed = event.keyCode
            if (keyPressed === 27) {
                event.preventDefault()
                this.hiddenModalBroadcastMailFailed()
                this.hiddenModalBroadcastMailPreview()
            }
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(true)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/clinic/broadcast/modal-broadcast-mail-failed.component.ts